const getInitialvalues = (filters) => {
  return {
    customer_id: filters.customer_id || [],
  };
};

export default getInitialvalues;
